const STORAGE_KEY = 'superAdminSelectedCompany';

export const getStoredSuperAdminCompany = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return null;
        const parsed = JSON.parse(stored);
        return parsed?.id ? parsed : null;
    } catch {
        return null;
    }
};

export const setStoredSuperAdminCompany = (company) => {
    if (!company?.id) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
        id: company.id,
        name: company.company_name || company.name || '',
        ucp_login_url: company.ucp_login_url || ''
    }));
};

export const clearStoredSuperAdminCompany = () => {
    localStorage.removeItem(STORAGE_KEY);
};

export const getSuperAdminCompanyParams = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const selectedCompany = getStoredSuperAdminCompany();
    return user.role === 'super_admin' && selectedCompany?.id
        ? { company_id: selectedCompany.id }
        : {};
};

export const requireSuperAdminCompany = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.role !== 'super_admin') return null;
    return getStoredSuperAdminCompany();
};
